export const PITCH_ORIENTATION = ['HORIZONTAL', 'VERTICAL', 'VERTICAL_REVERSE', 'HORIZONTAL_REVERSE'] as const;
export const PITCH_CROP = [
  'FULL_PITCH',
  'HOME_BOX',
  'HOME_THIRD',
  'HOME_HALF',
  'OPPOSITION_BOX',
  'OPPOSITION_THIRD',
  'OPPOSITION_HALF',
  'CENTRE_THIRD',
] as const;
export const EVENT_MARKERS_LIMIT = 6000;
export const ALL_EVENTS_METRIC_KEY = 'all_events';
export const PASS_RECIPIENT_EVENTS_LIMIT = 5000;

export const EVENT_MAP_LEGEND_XG_LABELS = ['0', '0.05', '0.1', '0.2', '0.5', '1'];

export const OBV_COLOUR_MAX = 0.1;

export const EVENT_MAP_LEGEND_OBV_LABELS = ['-0.1', '-0.05', '0', '+0.05', '+0.1'];

export const SAVED_SHOT_OUTCOMES = ['saved', 'saved_off_t', 'saved_to_post'];

export const OWN_GOAL_TYPE = 'own_goal_for';

export const SHOT_EVENT_TYPES = ['shot', OWN_GOAL_TYPE];

export const GOAL_OUTCOME = 'goal';

export const BLOCKED_OUTCOME = 'blocked';

export const SHOT_MAP_MARKER_STROKE_WIDTH = {
  DEFAULT: 0.1,
  SAVED: 0.25,
  GOAL: 0.3,
};

export const SHOT_MAP_GOAL_DASHARRAY = '0.3 0.1';

export const SHOT_MARKER_FILL_OPACITY = 0.8;

export const PITCH_COLOURING_MODES = ['default', 'none', 'xg', 'obv'] as const;

export const DEFAULT_MARKER_SHAPE = 'CIRCLE';
